import React, { useState, useEffect } from 'react';
import { Link, Navigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
// import { useTranslation } from 'react-i18next';
import AsyncSelect from 'react-select/async';

import Header from '../../components/Header';
import SimCard from '../../components/SimCard';

// Actions
import { gameActions, authActions } from '../../actions';

// Simulate list of mini digital activities
import apiCatalog from '../catalog/data';

const New = () => {
  // State
  const [state, setState] = useState({
    instructors: [],
    name: '',
    instructor: '',
    type: 'link',
  });

  // Hooks
  const user = useSelector((state) => state.authentication.user);
  const game = useSelector((state) => state.game);
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  // const { t } = useTranslation();

  // Get the simId from the URL
  const simId = searchParams.get('sid');

  // Logic
  const { name, instructor, type, instructors } = state;

  // Get the current sim data
  const simData = apiCatalog.find((sim) => sim._id === parseInt(simId));

  // Effect on Mount
  useEffect(() => {
    dispatch(authActions.me()); // Get the current user
  }, []);

  // Effects
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      instructors: [instructorDataToOption(user)],
      instructor: instructorDataToOption(user),
    }));
  }, [user]);

  // If there's game data, then Navigate to it
  useEffect(() => {
    if (game.data) {
      setState((prev) => ({
        ...prev,
        data: game.data,
      }));
    }
  }, [game.data]);

  // Methods
  const handleChange = (e) => {
    setState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const sortByName = (a, b) => {
    const fullNameEmailA = `${a.name} ${a.lastname} ${a.email}`
      ?.trim()
      .toLowerCase();
    const fullNameEmailB = `${b.name} ${b.lastname} ${b.email}`
      ?.trim()
      .toLowerCase();
    if (fullNameEmailA < fullNameEmailB) return -1;
    if (fullNameEmailA > fullNameEmailB) return 1;
    return 0;
  };

  const instructorDataToOption = (i) => {
    if (!i) return null;

    // Map the data to the format required by react-select
    const name =
      i?.name?.length > 0 || i?.lastname?.length > 0
        ? `${i?.name} ${i?.lastname} (${i.email})`.trim()
        : i?.email;

    return {
      value: i._id,
      label: `${name}`?.trim(),
    };
  };

  const hubGetFilteredUsers = async (inputValue = '') => {
    // Only proceed if inputValue is at least 3 characters long
    if (inputValue.length < 3) return [];

    // Define filters
    const queryString = `?role[]=instructor&role[]=administrator&email=${inputValue}`;
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/hub/users${queryString}`,
      {
        method: 'GET',
      }
    );
    const data = await response.json();

    const sortedData = data?.sort(sortByName)?.map(instructorDataToOption);
    setState((prev) => ({
      ...prev,
      instructors: sortedData,
    }));

    return sortedData;
  };

  const submit = () => {
    const data = {
      sim_id: simId,
      name: state.name,
      instructor: state.instructor?.value,
      access_type: state.type,
    };
    dispatch(gameActions.createGame(data));
  };

  // If there's game data, then Navigate to it
  if (game.data && game.data._id)
    return <Navigate to={`/games/${game.data._id}`} />;

  const canSubmit =
    simId?.length > 0 && // Check if simId is present
    name.length > 0 && // Check if name is not empty
    type.length > 0 && // Check if type is not empty
    instructor !== ''; // Check if instructor is selected

  return (
    <div className=''>
      <Header />

      <div className='row'>
        <div className='col-12 col-lg-6 offset-lg-3'>
          <h2 className='mt-3 fs-2 mt-4 fw-light mb-4'>New Session</h2>
          <div className='card bg-light shadow'>
            <div className='card-body p-4'>
              <div className='row'>
                {/* Sim Information */}
                <div className='mb-4'>
                  {simData && <SimCard {...simData} />}
                </div>

                {/* Session Name */}
                <div className='mb-4'>
                  <div className='input-group input-group-lg'>
                    <input
                      name='name'
                      className='form-control'
                      onChange={handleChange}
                      placeholder='Enter Game Name (Required)'
                    />
                  </div>
                </div>

                {/* Instructor */}
                <div className='input-group input-group-lg mb-5'>
                  {/* For Instructors */}
                  {user?.role === 'instructor' && (
                    <select
                      name='instructor'
                      className='form-control form-select'
                      value={instructor?._id}
                      onChange={handleChange}
                      disabled={user.role === 'instructor'}>
                      <option value=''>Select Instructor (Required)</option>
                      {instructors?.map((instructor) => (
                        <option key={instructor._id} value={instructor._id}>
                          {`${instructor.name} ${instructor.lastname} (${instructor.email})`}
                        </option>
                      ))}
                    </select>
                  )}

                  {/* For Admins */}
                  {['administrator', 'manager'].includes(user?.role) && (
                    <AsyncSelect
                      name='instructor'
                      classNamePrefix='react-select'
                      classNames={{
                        container: () => 'fs-5 w-100',
                        input: () => 'py-1',
                        control: () => 'px-2 border rounded-3',
                        indicatorSeparator: () => 'my-3',
                        menu: () => 'small',
                      }}
                      loadOptions={hubGetFilteredUsers}
                      onChange={(selectedOption) => {
                        setState((prev) => ({
                          ...prev,
                          instructor: selectedOption,
                        }));
                      }}
                      // options={instructors}
                      defaultOptions={state.instructors}
                      value={instructor}
                      placeholder='Search Instructor'
                      noOptionsMessage={() => 'No instructors found'}
                      isClearable
                      isSearchable
                    />
                  )}
                </div>

                {/* Buttons */}
                <div className='text-end'>
                  <Link to='/games' className='btn btn-light btn-lg me-2'>
                    Cancel
                  </Link>
                  <button
                    className='btn btn-outline-primary btn-lg ms-2'
                    disabled={!canSubmit}
                    onClick={submit}>
                    Create
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { New as GameNew };
